module.exports = __webpack_public_path__ + "img/NIS_Continuity.5e501631.svg";